import styled from 'styled-components'
import Paper from '@mui/material/Paper'
import Button from '@mui/material/Button'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`

export const Box = styled(Paper)`
  padding: 20px 16px;
`

export const Text = styled.span`
  display: block;
  margin-bottom: 30px;
  padding-left: 12px;
  color: #202020;
  letter-spacing: 0.15px;
`



export const CenteredButton = styled(Button)`
  &.MuiButtonBase-root {
    width: 36%;
    margin: auto;
  }
`

export const LabelValueBox = styled.div`
  display: flex;
  flex-direction: column;

  label { 
    margin-bottom: 8px;
  }

  span {
    font-size: 24px;
    font-weight: bold;
     ${(props) => 
      props.blue ? `
        color: #7F39FB;
      `
      : props.green ? `
        color: #01A299;
      ` : ''
    }
  }
`

export const UpperBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`

export const BigBox = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  ${(props) => 
    props.blue ? `
      border: 1px solid #7F39FB;
    `
    : props.green ? `
      border: 1px solid #01A299;
    ` : ''
  }
  padding: 20px;

  label { 
    margin-bottom: 8px;
  }

  span {
    font-size: 48px;
    font-weight: bold;
     ${(props) => 
      props.blue ? `
        color: #7F39FB;
      `
      : props.green ? `
        color: #01A299;
      ` : ''
    }
  }
`